export default "__VITE_ASSET__1xum3gYV__"